import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';

const Animation = ({ name, loop, autoplay, data, onAnimationCompleted, onAnimationLoopCompleted, isStopped, isPaused }) => {
  const options = useMemo(
    () => ({
      loop,
      autoplay,
      animationData: data,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet',
      },
    }),
    [loop, autoplay, data],
  );

  const eventListeners = useMemo(() => {
    const listeners = [];

    if (onAnimationCompleted) {
      listeners.push({
        eventName: 'complete',
        callback: () => onAnimationCompleted({ name }),
      });
    }

    if (onAnimationLoopCompleted) {
      listeners.push({
        eventName: 'loopComplete',
        callback: () => onAnimationLoopCompleted({ name }),
      });
    }
  }, [onAnimationCompleted, onAnimationLoopCompleted, name]);

  return (
    <Lottie data-testid={name} options={options} eventListeners={eventListeners} isStopped={isStopped} isPaused={isPaused} />
  );
};

Animation.propTypes = {
  name: PropTypes.string.isRequired,
  loop: PropTypes.bool,
  autoplay: PropTypes.bool,
  data: PropTypes.object.isRequired,
  onAnimationCompleted: PropTypes.func,
  onAnimationLoopCompleted: PropTypes.func,
  isStopped: PropTypes.bool,
  isPaused: PropTypes.bool,
};

Animation.defaultProps = {
  loop: false,
  autoplay: true,
  onAnimationCompleted: undefined,
  onAnimationLoopCompleted: undefined,
  isStopped: undefined,
  isPaused: undefined,
};

export default Animation;
